import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => (
  <SvgIcon>
    <svg fill="none">
      <path
        d="M12.0004 21L3.47805 11.8566C2.72905 11.0867 2.23469 10.0938 2.0651 9.0187C1.8955 7.94356 2.05928 6.84079 2.5332 5.86679V5.86679C2.89057 5.13177 3.41261 4.49462 4.05629 4.00784C4.69998 3.52105 5.4469 3.19857 6.23551 3.06695C7.02411 2.93534 7.83184 2.99836 8.59212 3.25082C9.35241 3.50329 10.0435 3.93797 10.6084 4.51906L12.0004 5.95L13.3923 4.51906C13.9573 3.93797 14.6484 3.50329 15.4087 3.25082C16.169 2.99836 16.9767 2.93534 17.7653 3.06695C18.5539 3.19857 19.3008 3.52105 19.9445 4.00784C20.5882 4.49462 21.1102 5.13177 21.4676 5.86679C21.9409 6.84042 22.1044 7.94253 21.935 9.01705C21.7655 10.0916 21.2718 11.084 20.5236 11.8539L12.0004 21Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  </SvgIcon>
);
